import { merge } from "lodash";
import { featureCollection } from "@turf/turf";
import Service from "@/services/service";

export default class StudyService extends Service {
  constructor() {
    super("studies");
  }

  read(id, options) {
    return this.get(`/${id}`, options);
  }

  create(info, options) {
    const { name, description, type, zones: features, ...config } = info;
    const study = { name, description, type };
    const zones = featureCollection(features);
    config.type = type;
    return this.post("", { study, zones, config }, options);
  }

  update(id, study, options) {
    return this.patch(`/${id}`, study, options);
  }

  remove(id, options) {
    return this.delete(`/${id}`, options);
  }

  getConfig(id, options) {
    return this.get(`/${id}/config`, options);
  }

  getZones(id, options) {
    return this.get(`/${id}/zones`, options);
  }

  getLog(id, options) {
    return this.get(`/${id}/log`, options);
  }

  listArtifacts(id, options) {
    return this.get(`/${id}/artifacts`, options);
  }

  listExecutions(id, options) {
    return this.get(`/${id}/executions`, options);
  }

  rerunMonth(id, month, options) {
    return this.get(`/${id}/rerun/${month}`, options);
  }

  uploadArtifact(id, formData, options) {
    options = merge(options, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return this.post(`/${id}/artifacts`, formData, options);
  }

  downloadArtifact(id, aid, options) {
    return this.get(`/${id}/artifacts/${aid}/download`, options);
  }

  execute(id, options) {
    return this.get(`/${id}/execute`, options);
  }

  getMaterializedView(id, options) {
    return this.get(`/${id}/materialized-view`, options);
  }
}
